import { render, staticRenderFns } from "./ProjectContentsSection.vue?vue&type=template&id=22933281&"
import script from "./ProjectContentsSection.vue?vue&type=script&lang=js&"
export * from "./ProjectContentsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports